interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'quickfit', src: './assets/scripts/jquery.quickfit.js'}
];